<template>
	<!-- 确认信息框 -->
	<el-dialog width="700" title="系统更新" v-model="productOpen" :close-on-click-modal="false" :close-on-press-escape="false">
		<div class="info">
			<div>
        更新内容：转产品申请 具体流程：
      </div> 
      <div>
        1. 需要转产品报备截图：与项目部或全国客服中心的报备截图 
      </div>
      <div>
        2. 在全款未完结中：点击转产品申请，发起转产品申请
      </div>
      <div>
        3. 等待财务审核，审核通过即转产品成功
      </div>
      <div style="display: flex;justify-content: center;">
        <el-button :disabled="readed" type="primary" style="width:200px;margin-top: 30px;" @click="productClose">我已知晓</el-button>
      </div>
		</div>
	</el-dialog>
</template>
<script setup>
import { onMounted, ref } from 'vue'

const productOpen = ref(true)
const readed = ref(true)
const time = ref()
const emit = defineEmits(['close'])
const productClose = () => {
	emit('close')
}
onMounted(()=>{
  localStorage.setItem('announcementNotice', 1)
  time.value = setInterval(()=>{
    readed.value = false
    clearInterval(time.value)
  },2000)
  
})
</script>
<style lang="scss" scoped>
.info {
	display: flex;
	flex-direction: column;
}
</style>
